export default __webpack_public_path__ + "0339a79b.jpg";